import { useEffect, useRef } from "react";

import { getFromUrl, jumpToSectionElement } from "../Modules/Helpers";

const usePageInitialScroll = <T extends HTMLElement>(queryParam: string, queryValue: string) => {
    const elementToScroll = useRef<T>();
    const timeoutRef = useRef<number>(0);

    useEffect(() => {
        const queryResult = getFromUrl(queryParam);
        if (queryParam && queryResult === queryValue) {
            timeoutRef.current = window.setTimeout(() => jumpToSectionElement(elementToScroll.current), 500);
        }

        return () => clearTimeout(timeoutRef.current);
    }, [queryParam, queryValue]);

    return elementToScroll;
};

export default usePageInitialScroll;
